import { useEffect, useState } from 'react';

/**
 * custom hook to debounce the value
 * default delay is 1000ms (1s)
 * @type {(debounceValue:string , delay:number) => string}
 */
const useDebounce = (debounceValue, delay = 1000) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setValue(debounceValue);
        }, delay);

        return () => {
            clearTimeout(handler);
            setValue('');
        };
    }, [debounceValue]);

    return value;
};

export default useDebounce;
